export default __webpack_public_path__ + "static/media/red-mountain-3.45d924a1.PNG";